/**
 * @generated SignedSource<<c21e592f294886568eca6cc51d226005>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LanguagePreference_component$data = {
  readonly categoryname: string | null | undefined;
  readonly info: {
    readonly " $fragmentSpreads": FragmentRefs<"CategoryInfo_info">;
  } | null | undefined;
  readonly items: ReadonlyArray<{
    readonly filtervalue: string | null | undefined;
    readonly label: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "LanguagePreference_component";
};
export type LanguagePreference_component$key = {
  readonly " $data"?: LanguagePreference_component$data;
  readonly " $fragmentSpreads": FragmentRefs<"LanguagePreference_component">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LanguagePreference_component",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CategoryInfo",
      "kind": "LinkedField",
      "name": "info",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CategoryInfo_info"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DetailFilterItem",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "filtervalue",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "categoryname",
      "storageKey": null
    }
  ],
  "type": "LanguagePreference",
  "abstractKey": null
};

(node as any).hash = "0706e0b4c8f23c53c86b24524b482b75";

export default node;
